<template>
    <component
        :is="href ? 'Link' : 'button'"
        :href="href"
        :type="!href ? type : null"
        :class="buttonClasses"
    >
        <font-awesome-icon
            :class="iconClass"
            class="text-white absolute w-full text-center origin-center transition-all"
            size="lg"
            :icon="['fas', 'tire']"
        ></font-awesome-icon>

        <span class="transition-all" :class="textClass">
            <slot />
        </span>
    </component>
</template>

<script>
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import { Link } from '@inertiajs/inertia-vue3'

export default {
    components: {FontAwesomeIcon, Link},
    props: {
        type: {
            type: String,
            default: "submit"
        },
        loading: Boolean,
        size: {
            type: String,
            default: "normal"
        },
        href: String,
        theme: {
            type: String,
            default: "primary"
        },
        disabled: Boolean
    },
    computed: {
        textClass() {
            return [
                this.loading ? ["invisible", "opacity-0"] : ["visible", "opacity-100"],
            ];
        },
        buttonClasses() {
            let classes = [
                "inline-flex",
                "items-center",
                "justify-center",
                "rounded-full",
                "font-bold",
                "active:bg-black",
                "focus:outline-none",
                "focus:ring-0",
                "appearance-none",
                "relative",
            ];

            // Button size
            if (this.size === "normal") {
                classes.push(["text-sm", "sm:text-lg", "py-2", "h-11", "px-5"]);
            } else if (this.size === "small") {
                classes.push(["text-sm", "py-1", "px-3"]);
            }

            // Button colour
            if (this.theme === "primary") {
                classes.push(["text-white", "bg-primary", "hover:bg-purple-300"]);
            } else if (this.theme === "secondary")
            {
                classes.push([
                    "text-dark",
                    "bg-gradient-to-tr",
                    "from-green-100",
                    "to-green-200",
                    "hover:text-white",
                    "linear"
                ]);
            } else if (this.theme === "white") {
                classes.push([
                    "text-dark",
                    "bg-white",
                    "hover:bg-dark",
                    "hover:text-white",
                    "linear"
                ]);
            } else if (this.theme === "orange")
            {
                classes.push([
                    "text-dark",
                    "bg-orange",
                    "hover:bg-primary",
                    "hover:text-white",
                    "linear"
                ]);
            }



            if (this.disabled) {
                classes.push([
                    "opacity-80",
                ]);
            }

            return classes;
        },
        iconClass() {
            if (this.loading) return ["visible", "opacity-100", "animate-spin"];

            return ['invisible', 'opacity-0'];
        }
    }
};
</script>

<style lang="scss" scoped>

</style>
